<template>
    <!-- 排课表 -->
    <div class="timeTableContent">
        <div class="flex jc-sb ai-c">
            <div class="modeChoose flex">
                <span @click="chengeModel('tableModle')" :class="activeName=='tableModle' ? 'active':''" class="tableModle item">表格模式</span>
                <span @click="chengeModel('dateModle')" :class="activeName=='dateModle' ? 'active':''" class="dateModle item">日历模式</span>
            </div>
            <div v-if="isShowPk===true" @click="handleSchedule" class="pk">排课</div>
        </div>
        <!-- 列表模式 -->
        <div v-if="activeName === 'tableModle'" class="listBox">
            <ListModel ref="ListModel" />
        </div>
        <!-- 日历/时间模式 -->
        <div v-if="activeName === 'dateModle'" class="timeBox">
            <DateModle ref="DateModle" />
        </div>
        <!-- 日历规则排课 -->
        <Schedule ref="Schedule" />
    </div>
</template>
<script>
import ListModel from './schedule/listModel.vue'
import DateModle from '../../components/dateModle.vue'
import Schedule from '@/views/meas/teachManagement/timetableManagement/componetns/schedule.vue'
export default {
    data(){
        return {
            activeName: 'tableModle',
            classCode: this.$route.query.code
        }
    },
    components: {
        ListModel,
        Schedule,
        DateModle
    },
    props: ['isShowPk','className'],
    methods: {
        chengeModel(activeName){
            this.activeName = activeName
            if(activeName === 'tableModle'){
               this.$nextTick(() => {
                 this.$refs.ListModel.init(this.classCode)
               })
            }
        },
        handleSchedule(){
            this.$refs.Schedule.init(this.classCode, this.className)
        },
        init(){
             this.$nextTick(() => {
                this.$refs.ListModel.init(this.classCode)
             })
        }
    }
}
</script>
<style lang="scss" scoped>
.timeTableContent{
    .pk{
        flex-shrink: 0;
        color: #0B75FA;
        cursor: pointer;
    }
    .modeChoose{
        align-items: center;
        width: 100%;
        border-radius: 4px;
        .item{
            font-size: 14px;
            padding: 10px 20px;
            border: 1px solid #E4E7EC;
            cursor: pointer;
        }
        .tableModle{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        .dateModle{
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border-left: none;
        }
        .active{
            background: #0B75FA;
            color: white;
        }
    }
}
</style>